export default __webpack_public_path__ + "static/media/tavi_main.990f24ef.jpg";